var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="vis--row_bar bar--count_'+
((__t=( count ))==null?'':__t)+
'"> <div class="vis--horiz_bar_container" data-type="'+
((__t=( category ))==null?'':__t)+
'"> <div data-company="'+
((__t=( company ))==null?'':__t)+
'" data-category="'+
((__t=( display ))==null?'':__t)+
'" data-value="'+
((__t=( value ))==null?'':__t)+
'" class="vis--horiz_bar vis--bar_'+
((__t=( category ))==null?'':__t)+
'" style="width: '+
((__t=( pct ))==null?'':__t)+
'"></div> </div> </div>';
}
return __p;
};
